import { Button } from "@waypoint/surface";
import { Link } from "wouter";
import { t } from "../i18n/t.js";
import { EmptyState, Page } from "./page.js";

export function NotFoundPage() {
  return (
    <Page title={t("page.notFound.title")}>
      <EmptyState icon="alert" title={t("page.notFound.line")}>
        <Button asChild className="mt-3">
          <Link href="~/learn">{t("page.notFound.home")}</Link>
        </Button>
      </EmptyState>
    </Page>
  );
}
